// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FmAqE","textarea":"styles_textarea__3fi9k"};